<template>
  <transition name="fade" appear>
    <div class="modal" v-if="show">
      <div class="modal__backdrop" @click="closeModal()"/>

      <div class="modal__dialog">
        <div class="modal__header">
          <slot name="header"/>
          <span type="button" class="modal__close" @click="closeModal()">×</span>
        </div>

        <div class="modal__body">
          <slot name="body"/>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Modal",
  data() {
    return {
      show: false
    }
  },
  methods: {
    closeModal() {
      this.show = false;
      document.querySelector("body").classList.remove("overflow-hidden");
    },
    openModal() {
      this.show = true;
      document.querySelector("body").classList.add("overflow-hidden");
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: var(--background-color);
  margin: 0 auto;
  width: 100vw;
  &__backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    height: 100vh;
    background-color: var(--background-color);
  }
  &__dialog {
    width: 100vw;
    margin: 0 auto;
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    background-color: var(--background-color);
  }
  &__close {
    font-size: 35px;
    margin: 0;
    cursor: pointer;
  }
  &__header {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    padding: 0 15px;
    box-sizing: content-box;
    background-color: var(--background-color);
  }
  &__body {
    text-align: center;
    margin: 0 auto;
    background-color: var(--background-color);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all .2s linear;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>